module.exports = __webpack_public_path__ + "img/catalogo_produtos_online_icon.8f4c889b.svg";